import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as DeviceActions from "src/app/store/device/device.actions";
import { Observable } from "rxjs";
import { AppState } from "../app.reducer";
import { Device } from "@core/models/domain/device.domain";
import { selectAllDevices, selectDeviceById, selectDeviceError, selectDeviceLoading } from "./device.selectors";
import { DeviceRegistrationRequest } from "@core/models/request/device.request";

@Injectable({ providedIn: 'root' })
export class DeviceStoreFacade {
    devices$: Observable<Device[]> = this.store.select(selectAllDevices);
    error$: Observable<string | null> = this.store.select(selectDeviceError);
    loading$: Observable<boolean> = this.store.select(selectDeviceLoading);

    constructor(private store: Store<AppState>) {}

    // Store-first: renders the cached devices instantly and only fetches when the
    // cache is empty, stale or invalidated.
    loadDevicesIfNeeded(): void {
        this.store.dispatch(DeviceActions.loadDevicesIfNeeded());
    }

    loadDevices(): void {
        this.store.dispatch(DeviceActions.loadDevices());
    }

    registerDevices(request: DeviceRegistrationRequest): void {
        this.store.dispatch(DeviceActions.registerDevices({ request }));
    }

    removeDevice(deviceId: string): void {
        this.store.dispatch(DeviceActions.removeDevice({ deviceId }));
    }

    getDevice(deviceId: string): Observable<Device | undefined> {
        return this.store.select(selectDeviceById(deviceId));
    }
}